// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"styles_formContainer__3Xgbd","imageContainer":"styles_imageContainer__2FE0t"};